import { render, staticRenderFns } from "./RegistroCivil.vue?vue&type=template&id=91d2286e&"
import script from "./RegistroCivil.vue?vue&type=script&lang=js&"
export * from "./RegistroCivil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports